import { render } from "./QC4AreaRetention.vue?vue&type=template&id=62e3f37a"
import script from "./QC4AreaRetention.vue?vue&type=script&lang=js"
export * from "./QC4AreaRetention.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/QCCharts/microgen/QC4AreaRetention.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "62e3f37a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('62e3f37a', __exports__)) {
    console.log('reload')
    api.reload('62e3f37a', __exports__)
  }
  
  module.hot.accept("./QC4AreaRetention.vue?vue&type=template&id=62e3f37a", () => {
    console.log('re-render')
    api.rerender('62e3f37a', render)
  })

}


export default __exports__